import {useMutation} from '@tanstack/react-query';
import {AccountId} from '~/entities/operations-fiat';
import {ErroneousServerResult, expectEither, HttpClient, POST, useHttpClient} from '~/library/network-facade';

export function validateAmount(http: HttpClient, accountId: AccountId, amount: string) {
    return http(`v1/accounts/${accountId}/send/banks/limit`, POST({amount})).then(
        ...expectEither({
            204: null,
            400: ErroneousServerResult,
        })
    );
}

export function useValidateAmount(accountId: AccountId) {
    const http = useHttpClient();
    return useMutation({
        mutationKey: ['v1/accounts/{accountId}/send/banks/limit', accountId],
        mutationFn: async (amount: string) => {
            const res = await validateAmount(http, accountId, amount);

            switch (res.status) {
                case 204:
                    return {ok: true} as const;
                case 400:
                    return {ok: false, issues: res.json} as const;
                case 'Abort':
                    throw res.reason;
            }
        },
    });
}
